import get from 'lodash/get';
import actionTypes, {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from './types';

const initialState = {
  productDetail: {
    loading: false,
    data: {},
    error: null,
  },
  createDocumentTab: {
    loading: false,
    data: {},
    error: null,
  },
  updateDocumentTab: {
    loading: false,
    data: {},
    error: null,
  },
  deleteDocumentTab: {
    loading: false,
    data: {},
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypeRequest(actionTypes.GET_PRODUCT_DETAIL): {
      return {
        ...state,
        productDetail: {
          ...state.productDetail,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_PRODUCT_DETAIL): {
      return {
        ...state,
        productDetail: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_PRODUCT_DETAIL): {
      return {
        ...state,
        productDetail: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(actionTypes.CREATE_DOCUMENT_TAB): {
      return {
        ...state,
        productDetail: {
          ...state.productDetail,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.CREATE_DOCUMENT_TAB): {
      return {
        ...state,
        productDetail: {
          ...state.productDetail,
          loading: false,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.CREATE_DOCUMENT_TAB): {
      return {
        ...state,
        productDetail: {
          ...state.productDetail,
          loading: false,
          error: get(action, 'error'),
        },
      };
    }
    default: {
      return state;
    }
  }
};
